//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Systemic_lupus_erythematosus_activity_score",
  data() {
    return {
      form: {
        value1: "0",
        value2: "0",
        value3: "0",
        value4: "0",
        value5: "0",
        value6: "0",
        value7: "0",
        value8: "0",
        value9: "0",
        value10: "0",
        value11: "0",
        value12: "0",
        value13: "0",
        value14: "0",
        value15: "0",
        value16: "0",
        value17: "0",
        value18: "0",
        value19: "0",
        value20: "0",
        value21: "0",
        value22: "0",
        value23: "0",
        value24: "0",
      },
      hasScore: false,
      disabled: false,
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "0";
      } else {
        // chf+mi+periphVasc+cerebroVasc+pulmonary+liver+ulcer+dm+renal*2+tumor*2+metastatic*6+leukemia*2+lymphoma*2+aids*6+tissue+dementia+hemiplegia*2
        let result =
          form.value1*8 + form.value2*8 + form.value3*8 + form.value4*8 + form.value5*8
          +form.value6*8 +
          form.value7*8 + 
          form.value8*8 + 
          form.value9*4 +
          form.value10*4 + 
          form.value11*4 + 
          form.value12*4 + 
          form.value13*4 + 
          form.value14*4 + 
          form.value15*2 + 
          form.value16*2 + 
          form.value17*2 + 
          form.value18*2 + 
          form.value19*2 + 
          form.value20*2 + 
          form.value21*2 + 
          form.value22 + 
          form.value23 + 
          form.value24

        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Systemic_lupus_erythematosus_activity_score.vue